import { useState, useEffect } from 'react';
import api from '@/lib/api';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { useConfirmation } from '../shared/ZCard';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';

// ==================== FLOW EDIT DIALOG ====================
export function FlowEditDialog({ open, onClose, settings, onSave }) {
  const feedback = useConfirmation();
  const [name, setName] = useState('');
  const [tagline, setTagline] = useState('');

  useEffect(() => {
    if (settings) {
      setName(settings.name || 'Flow');
      setTagline(settings.tagline || 'The current edit');
    }
  }, [settings, open]);

  const save = async () => {
    try {
      await api.put('/framed/flow-settings', { name, tagline });
      feedback.confirm();
      onSave();
      onClose();
    } catch { feedback.fail(); }
  };

  return (
    <Dialog open={open} onOpenChange={v => !v && onClose()}>
      <DialogContent className="bg-white/[0.02] border-white/[0.06] text-[#f0f0f5] max-w-md" aria-describedby="flow-edit-desc">
        <DialogHeader><DialogTitle style={{ fontFamily: "'Playfair Display', serif" }}>Edit Flow</DialogTitle></DialogHeader>
        <p id="flow-edit-desc" className="sr-only">Edit Flow stream settings</p>
        <div className="space-y-4 mt-2">
          <Input value={name} onChange={e => setName(e.target.value)} placeholder="Name"
            className="bg-[#0a0a0f] border-white/[0.06] text-[#f0f0f5] placeholder:text-[#6b7084]"
            style={{ fontFamily: "'Playfair Display', serif" }} data-testid="flow-name-input" />
          <Textarea value={tagline} onChange={e => setTagline(e.target.value)} placeholder="Tagline"
            className="bg-[#0a0a0f] border-white/[0.06] text-[#f0f0f5] placeholder:text-[#6b7084] min-h-[60px]"
            style={{ fontFamily: "'Cormorant Garamond', serif" }} data-testid="flow-tagline-input" />
          <Button onClick={save} disabled={!name.trim()} className="w-full bg-[#6B35B8] hover:bg-[#6B35B8]/90 text-white rounded-full" data-testid="flow-save-btn">
            Update
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
